<button class="btn btn-default btn-secondary float-end notifications" aria-label="Benachrichtigungen" [popover]="notificationsTemplate"
  placement="bottom" container="body" #pop="bs-popover" [outsideClick]="true" (click)="getNotifications()"
  [containerClass]="isMobile ? 'notifications-popover mobile-popover' : 'notifications-popover'">
  <i class="icon-notification" [ngClass]="{'mobile': isMobile}"></i>
  @if (!!totalUnRead) {
    <div class="unread-dot"></div>
  }
</button>

<ng-template #notificationsTemplate>
  <div class="d-flex justify-content-between notifications-title">
    <h4 class="m-0">Benachrichtigungen</h4>
    <a class="d-flex pointer" href="/settings/notifications" (click)="openSettings($event)">
      <p class="details">Einstellungen</p>
      <div class="settings-wrapper">
        <i class="icon-settings"></i>
      </div>
    </a>
  </div>
  <div class="d-flex justify-content-between notifications-control">
    <label class="form-check form-switch">
      <input class="form-check-input pointer" type="checkbox" role="switch" (change)="toggleSettingsNotifications()"
        [checked]="params.showOnlyUnread">
      <div class="form-check-label d-flex ml-3">
        <p class="form-check-label">Nur ungelesen anzeigen</p>
        <p class="unread-count">{{totalUnRead}}</p>
      </div>
    </label>
    @if (notifications.length) {
      <div class="d-flex">
        <i class="icon-delete active-icon" (click)="deleteNotifications('', true, $event)"></i>
        <i class="icon-check active-icon" (click)="readNotifications('', true, $event)"></i>
      </div>
    }
  </div>
  @if (notifications.length || (uploadFileService.isFilesUploading$ | async)) {
    <ul class="notification-menu" (scroll)="onScroll($event)"
      >
      @if (uploadFileService.isFilesUploading$ | async) {
        <a class="notification upload d-flex border-bottom"
          href="/wastewater/upload-content/upload"
          (click)="goToUpload($event)">
          <i class="icon-upload"></i>
          <div class="d-flex flex-column w-100">
            <div class="d-flex">
              <p class="title flex-grow-1">{{uploadFileService.filesAlreadyUpload$ | async | fileSize}} von
              {{uploadFileService.filesShouldUpload$ | async | fileSize}} hochgeladen</p>
              <p class="passed">now</p>
              <div class="read-notification"></div>
            </div>
            <div class="progress mt-2">
              <div class="progress-bar" role="progressbar"
                [style.width.%]="(((uploadFileService.filesAlreadyUpload$ | async) ?? 0) / ((uploadFileService.filesShouldUpload$ | async) ?? 0) * 100 ) | number:'1.0-0'"
                aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
              </div>
            </div>
          </div>
        </a>
      }
      @for (not of notifications; track not; let i = $index) {
        <a data-tooltip-no-anchor (click)="navigate(not, $event)"
          [href]="getNotificationUrl(not)"
          class="notification d-flex py-2 border-bottom" [ngClass]="{'unread': !not.isRead, 'notification-tenant': isCurrentTenant(not.linkToUrl), 'mention': not.type === notificationType.Mention}">
          @if (not.type === notificationType.Mention || not.type === notificationType.InspectionTicketFlow) {
            <div class="icon-wrapper">
              <i [class]="notificationIconsType[not.type]"></i>
            </div>
            <div class="d-flex flex-column w-100">
              <div class="d-flex">
                <p class="title flex-grow-1">{{getMentionHeader(not)}}</p>
                <p class="passed">{{not.date | timePast}}</p>
                @if (!not.isRead) {
                  <div class="read-notification" tooltip="Als gelesen markieren"
                  (click)="readNotifications(not.id, false, $event)"></div>
                }
                @if (not.isRead) {
                  <div class="read-notification read"></div>
                }
              </div>
              @if (getNotificationTenantName(not)) {
                <p class="tenant">{{getNotificationTenantName(not)}}</p>
              }
              @if (not.type !== notificationType.Mention || getMentionContent(not.text)) {
                <p class="text fw-semibold">{{not.type === notificationType.Mention ? getMentionContent(not.text): getTicketDetailParts(not.text)[0]}}</p>
              }
              @if (not.type === notificationType.Mention) {
                <p class="text"><span class="fw-semibold">{{getMentionName(not.text)}}</span>{{getMentionSuffix(not.text)}}</p>
              }
              @if (not.type === notificationType.InspectionTicketFlow) {
                <p class="text" [innerHTML]="getTicketDetailParts(not.text)[1]"></p>
              }
            </div>
          } @else {
            <div class="icon-wrapper">
              <i [class]="notificationIconsType[not.type]"></i>
            </div>
            <div class="d-flex flex-column w-100">
              <div class="d-flex">
                <p class="title flex-grow-1">{{notificationType[not.type]}}</p>
                <p class="passed">{{not.date | timePast}}</p>
                @if (!not.isRead) {
                  <div class="read-notification" tooltip="Als gelesen markieren"
                  (click)="readNotifications(not.id, false, $event)"></div>
                }
                @if (not.isRead) {
                  <div class="read-notification read"></div>
                }
              </div>
              @if (isCurrentTenant(not.linkToUrl)) {
                <p class="tenant">{{getTenantByLink(not.linkToUrl)}}</p>
              }
              <p class="text">{{not.text}}</p>
            </div>
          }
        </a>
      }
    </ul>
  } @else {
    <div class="no-data">
      <i class="icon-notification"></i>
      <p>Es sind noch keine Benachrichtigungen eingegangen</p>
    </div>
  }
</ng-template>
